import { getToken, getUser } from "../Utils/Common";
import {
  getAPICall,
  postAPICall,
  putAPICall,
  deleteAPICall,
} from "./axiosMethodCalls";

const user = getUser();
const token = getToken();

//GET ALL TRANSACTIONS
export const getAllTransactions = async () => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "bank_transfers/get_all_bank_transfer",
      {
        requester: getUser(),
        token: getToken(),
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

//GET SINGLE TRANSACTION
export const getTransaction = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "bank_transfers/get_bank_transfer",
      {
        requester: getUser(),
        token: getToken(),
        bank_transfer_id: id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

//SEARCH TRANSACTIONS
export const searchTransactions = async (filters = {}) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "bank_transfers/search",
      {
        requester: getUser(),
        token: getToken(),
        ...filters,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

//CREATE TRANSACTION
export const createTransaction = async (data) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "bank_transfers/create",
      {
        requester: getUser(),
        token: getToken(),
        transaction_date: data.transaction_date,
        reference_no: data.reference_no, // Send the reference number to backend
        bank_from_id: data.bank_from_id,
        bank_to_id: data.bank_to_id,
        amount: data.amount,
        remarks: data.remarks,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

//UPDATE TRANSACTION
export const updateTransaction = async (id, data) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "bank_transfers/update",
      {
        token: token,
        requester: user,
        bank_transfer_id: id,
        transaction_date: data.transaction_date,
        reference_no: data.reference_no,
        bank_from_id: data.bank_from_id,
        bank_to_id: data.bank_to_id,
        amount: data.amount,
        remarks: data.remarks,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

//DELETE TRANSACTION
// export const deleteTransaction = async (bank_transfer_id) => {
//     try {
//         const response = await deleteAPICall(
//             process.env.REACT_APP_LINK + "bank_transfers/delete_transaction" + bank_transfer_id
//         );
//         return { data: response.data };
//     } catch (error) {
//         return { error: error.response };
//     }
// };

export const deleteTransaction = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "bank_transfers/delete_transfer",
      {
        token: token,
        requester: user,
        bank_transfer_id: id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

// export const deleteTransaction = async (transaction_id) => {
//   try {
//     const response = await postAPICall(
//       process.env.REACT_APP_LINK + "bank_transfers/delete_transaction",
//       {
//         transaction_id: transaction_id,
//         token: getToken(),
//         requester: getUser(),
//       }
//     );
//     return response.data;
//   } catch (error) {
//     return { error: error.response };
//   }
// };

// export const deleteTransaction = async (
//   transaction_id
// ) => {
//   try {
//     const response = await postAPICall(
//       process.env.REACT_APP_LINK +
//         "bank_transfers/delete?create_transaction",
//       {
//         transaction_id: transaction_id,
//       }
//     );
//     return response.data;
//   } catch (error) {
//     return { error: error.response };
//   }
// };

//POST BANK RECONCILIATION TRANSACTION (for integration)
export const postTransactionBankReconciliation = async (data) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "reports/",
      {
        requester: getUser(),
        token: getToken(),
        bank_id: data.bank_id,
        reference_no: data.reference_no,
        transaction_date: data.transaction_date,
        amount: data.amount,
        type: data.type, // "Debit" or "Credit"
        description: data.description,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
